import React, { Component } from 'react';

import { List } from 'material-ui/List';

import InstructorDetails from './InstructorDetails';
import InstructorListItem from './InstructorListItem';
import * as ParseService from '../../../services/parse';

class CourseInstructorList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      selectedItem: null,
    };
  }

  componentDidMount() {
    this.fetchItems(this.props.course);
  }

  componentWillReceiveProps(props) {
    if (props.course.id !== this.props.course.id) {
      this.setState({items: []});
      this.fetchItems(props.course);  
    }
  }

  fetchItems = (course) => {
    const that = this;
    
    ParseService.findInstructorsByCourse(course, {
      success: function(results) {
        //if (that.props.course.id === course.id) {
          that.setState({items: results});  
        //} 
      },
      failure: function(err) {
        console.log('Failed to fetch course Instructors ' + err);
      }
    });
  }

  render() {
    const selectedItem = this.state.selectedItem

    return (
      <div className='course-instructor-list list-content'>
        <div className='course-relation__title'>Instructors</div>

        <div className='list-content__list'>
          <List>
            {this.state.items.map((item) =>
              <InstructorListItem 
                item={item} 
                onItemSelect={() => this.setState({selectedItem: item})} />
            )}
          </List>
        </div>

        { this.state.selectedItem != null ? (
          <InstructorDetails 
            item={selectedItem} 
            onItemDetailsClose={() => this.setState({selectedItem: null})} />
        ) : null }
      </div>
    );
  }
} 

export default CourseInstructorList;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/CourseInstructorList.js